import React, { Component } from 'react';
import '../myutils';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import SettingsIcon from '@material-ui/icons/Settings';
import { withRouter } from 'react-router-dom';
import SubMenu from './SubMenu';
import UserIcon from '@material-ui/icons/VerifiedUser';
import { translate, DashboardMenuItem, MenuItemLink, Responsive } from 'react-admin';
import DialerSip from '@material-ui/icons/DialerSip';
import CommunicationContactPhone from '@material-ui/icons/ContactPhone';
import CommunicationDialpad from '@material-ui/icons/Dialpad';
import ActionSchedule from '@material-ui/icons/Schedule';
import ActionSettingsPhone from '@material-ui/icons/SettingsPhone';
import PermPhoneMsg from '@material-ui/icons/PermPhoneMsg';
import InsertChart from '@material-ui/icons/InsertChart';
import PieChart from '@material-ui/icons/PieChart';
import List from '@material-ui/icons/List';

const items = [
    { name: 'Profile', to: 'Profile/1', icon: <UserIcon /> },
    { name: 'IVR', to: 'IVR?filter={"path":"ivr2:"}', icon: <CommunicationDialpad /> },
    { name: 'Customers', to: 'Customers', icon: <List /> },
    { name: 'Softphone', to: 'Softphone', icon: <DialerSip /> },
];


class Menu extends Component {
    state = {
        menuCatalog: false,
        menuCampaigns: false,
        menuCustomers: false,
    };

    static propTypes = {
        onMenuClick: PropTypes.func,
        logout: PropTypes.object,
    };

    handleToggle = menu => {
        this.setState(state => ({ [menu]: !state[menu] }));
    };
    

    render() {
        if (sessionStorage.C==undefined) sessionStorage.setItem('C', 'ADMIN'.encodeDecode());
        const { onMenuClick, open, logout, translate } = this.props;
        return (
            <div>
                {/* {' '} */}
            {(sessionStorage.C.encodeDecode()==='ADMIN'||sessionStorage.C.encodeDecode()==null)&&(<DashboardMenuItem onClick={onMenuClick} />)}
            {(sessionStorage.C.encodeDecode()==='ADMIN'||sessionStorage.C.encodeDecode()==null)?(items.map(item => (
                <MenuItemLink
                    key={item.name}
                    to={`/${item.to}`}
                    primaryText={translate(`resources.${item.name}.name`, { smart_count: 2 })}
                    leftIcon={item.icon}
                    onClick={onMenuClick}
                />
            ))):(<MenuItemLink
                to={`/IVR?filter={"path":"ivr2:"}`}
                name='IVR'
                primaryText={translate(`resources.IVR.name`, {
                    smart_count: 1,
                })}
                leftIcon={<CommunicationDialpad />}
                onClick={onMenuClick}
            />)}
            {(sessionStorage.C.encodeDecode()==='ADMIN')&&(<>
                <SubMenu
                    handleToggle={() => this.handleToggle('menuCampaigns')}
                    isOpen={this.state.menuCampaigns}
                    sidebarIsOpen={open}
                    name={translate('resources.campaigns.name')}
                    icon={<PermPhoneMsg />}
                >
                    <MenuItemLink
                        to={`/Templates`}
                        name='Templates'
                        primaryText={translate(`resources.templates.name`, {
                            smart_count: 1,
                        })}
                        leftIcon={<CommunicationContactPhone />}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/ActiveCampaigns`}
                        primaryText={translate(`resources.activecampaigns.name`, {
                            smart_count: 2,
                        })}
                        leftIcon={<ActionSettingsPhone />}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/ScheduledCampaigns`}
                        primaryText={translate(`resources.scheduled.name`, {
                            smart_count: 3,
                        })}
                        leftIcon={<ActionSchedule />}
                        onClick={onMenuClick}
                    />
                </SubMenu>
                <MenuItemLink
                        to={`/Statistics`}
                        name='Statistics'
                        primaryText={translate(`resources.Statistics.name`, {
                            smart_count: 1,
                        })}
                        leftIcon={<InsertChart />}
                        onClick={onMenuClick}
                    />                
                <MenuItemLink
                        to={`/UnitsStatistics`}
                        name='UnitsStatistics'
                        primaryText={translate(`resources.UnitsStatistics.name`, {
                            smart_count: 1,
                        })}
                        leftIcon={<PieChart />}
                        onClick={onMenuClick}
                    /></>)}                
                <MenuItemLink
                        to={`/configuration`}
                        name='Configurtaion'
                        primaryText={translate(`resources.Configuration.name`, {
                            smart_count: 1,
                        })}
                        leftIcon={<SettingsIcon />}
                        onClick={onMenuClick}
                    />                
                <Responsive
                    xsmall={
                        <MenuItemLink
                            to="/configuration"
                            primaryText={translate('pos.configuration')}
                            leftIcon={<SettingsIcon />}
                            onClick={onMenuClick}
                        />
                    }
                />
                <Responsive
                    small={logout}
                    medium={null} // Pass null to render nothing on larger devices
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    open: state.admin.ui.sidebarOpen,
    theme: state.theme,
    locale: state.i18n.locale,
});

const enhance = compose(
    withRouter,
    connect(
        mapStateToProps,
        {}
    ),
    translate
);

export default enhance(Menu);